import { render, staticRenderFns } from "./ExpandableZipArea.vue?vue&type=template&id=ff44aa22&scoped=true"
import script from "./ExpandableZipArea.vue?vue&type=script&lang=js"
export * from "./ExpandableZipArea.vue?vue&type=script&lang=js"
import style0 from "./ExpandableZipArea.vue?vue&type=style&index=0&id=ff44aa22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff44aa22",
  null
  
)

export default component.exports